import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import { useMutation } from '@apollo/react-hooks';
import toast from 'react-hot-toast';
import colors from '../../styles/colors';
import Input, { PhoneNumberInput } from '../Input';
import Button from '../Button';
import AccessLevels from '../../util/AccessLevels';
import { CREATE_ROLE, FIND_USER_BY_PHONE_NUMBER, GET_ORGANIZATION_ROLES } from '../../graphql/queries';
import { getErrorMessage } from '../../util/ErrorUtil';
import { useDebounce } from '../../util/debounce';

const Form = styled.form`
  padding: 20px 15px;
`;

const DropdownHeader = styled.div`
  font-size: 1.2rem;
  color: ${colors.grey3};
  margin: 30px 0px 10px 0px;
`;

const DropdownContainer = styled.div`
  font-size: 1.3rem;
  max-width:400px;
`;

const options = [
  { value: AccessLevels.Admin, label: AccessLevels.Admin },
  { value: AccessLevels.Server, label: AccessLevels.Server },
];

export default function AddTeamMemberModal({ close }) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [isEmailAutoFilled, setIsEmailAutoFilled] = useState(false);
  const [accessLevel, setAccessLevel] = useState({ value: AccessLevels.Admin, label: AccessLevels.Admin });
  const [findUserByPhoneNumber] = useMutation(FIND_USER_BY_PHONE_NUMBER);
  const [createRole, { loading }] = useMutation(CREATE_ROLE, {
    refetchQueries: [{ query: GET_ORGANIZATION_ROLES }],
    onError(error) {
      toast.error(getErrorMessage(error));
    },
    onCompleted(data) {
      console.log(data);
      close();
    },
  });



    const findUser = useDebounce(async (phone) => {
    if (phone) {
      try {
        const res = await findUserByPhoneNumber({ variables: { phoneNumber: phone } });
        const user = res?.data?.findUserByPhoneNumber;
        if (user?.email) {
          setEmail(user.email);
             setIsEmailAutoFilled(true);
        }else {
          setIsEmailAutoFilled(false);
        }
      } catch (err) {
           setIsEmailAutoFilled(false);
        console.warn('User not found or error fetching user');
      }
    }
  }, 500)


     useEffect(() => {
    findUser(phoneNumber);
    return () => {
      findUser.cancel();
    };
  }, [phoneNumber]);



  const handleSubmit = async (e) => {
    e.preventDefault();
    let userId = null;
    try {
      const res = await findUserByPhoneNumber({ variables: { phoneNumber } });
      const user = res?.data?.findUserByPhoneNumber;
      if (user?._id) {
        userId = user._id;
      }
    } catch (err) {
      console.warn('User not found, proceeding without userId');
    }
    const roleData = {
      variables: {
        phoneNumber,
        accessLevel: accessLevel.value,
        email
      },
    };
    if (userId && userId != null) {
      roleData.variables.userId = userId;
    }
    createRole(roleData);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <PhoneNumberInput
        top
        type="tel"
        header="PHONE NUMBER"
        value={phoneNumber}
        onChange={(e) => {setPhoneNumber(e.target.value);
           setIsEmailAutoFilled(false);
          }}
        width="calc(100%)"
        required
      />
       <Input
         margin="15px 0px 0px 0px"
         top
         type="email"
         header="EMAIL"
         value={email}
         onChange={(e) => setEmail(e.target.value)}
         required
         width="100%"
         disabled={isEmailAutoFilled}
         />
      <DropdownHeader>
        Role
      </DropdownHeader>
      <DropdownContainer>
        <Select
          defaultValue={accessLevel}
          value={accessLevel}
          onChange={(val) => setAccessLevel(val)}
          options={options}
        />
      </DropdownContainer>
      <Button
        margin="80px 0px 0px 0px"
        text="SEND INVITE"
        type="submit"
        width="100%"
        loading={loading}
      />
    </Form>
  );
}
